import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, ToastController} from 'ionic-angular';
import {AcknowledgmentsService} from "../../services/acknowledgments.service";
import {take} from "rxjs/operators";

@IonicPage()
@Component({
  selector: 'page-admin-acknowledgments',
  templateUrl: 'admin-acknowledgments.html',
})
export class AdminAcknowledgmentsPage {

  acks: string;

  constructor(public navCtrl: NavController,
              private ackService: AcknowledgmentsService,
              public loadingCtrl: LoadingController,
              private toastCtrl: ToastController,
              public navParams: NavParams) {
    const loader = this.loadingCtrl.create({
      content: "Chargement..."
    });
    loader.present();
    this.ackService.get().pipe(take(1)).subscribe( acks => {
      this.acks = acks;
      loader.dismissAll();
    })
  }

  ionViewDidLoad() {

  }

  save() {
    this.ackService.save(this.acks).then(
      ok => {
        const toast = this.toastCtrl.create({
          message: 'Enregistré',
          duration: 3000
        });
        toast.present();
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-acknowledgments/admin-acknowledgments.ts